export const reduxKey = '@@favouritedByModal';
